// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-collection-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.bulk-collection-header {
  background-color: #0d47a1;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bulk-collection-header h1 {
  margin: 0;
  font-size: 1.5rem;
  flex-grow: 1;
  text-align: center;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.back-button {
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.back-button span {
  margin-left: 0.5rem;
}

.bulk-collection-content {
  flex-grow: 1;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.current-rate-info {
  background-color: #e3f2fd;
  color: #0d47a1;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  font-weight: bold;
  text-align: center;
  border: 1px solid #bbdefb;
}

.rate-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rate-display p {
  margin: 0;
}

.edit-rate-button {
  background-color: transparent;
  color: #0d47a1;
  border: 1px solid #0d47a1;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.edit-rate-button:hover {
  background-color: #bbdefb;
}

.edit-rate-button span {
  margin-left: 0.5rem;
}

.rate-edit {
  display: flex;
  align-items: center;
  justify-content: center;
}

.rate-input {
  margin: 0 0.5rem;
  padding: 0.5rem;
  width: 100px;
  border: 1px solid #bbdefb;
  border-radius: 4px;
  font-size: 1rem;
  text-align: center;
}

.save-rate-button {
  background-color: #0d47a1;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.save-rate-button:hover {
  background-color: #0a3880;
}

.save-rate-button span {
  margin-left: 0.5rem;
}

.success-message,
.error-message {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}

.success-message {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}

.success-message svg,
.error-message svg {
  margin-right: 0.75rem;
}

.collections-container {
  margin-bottom: 2rem;
}

.no-collections {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: #666;
}

.collection-form {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.collection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #eee;
}

.collection-header h3 {
  margin: 0;
  color: #0d47a1;
}

.remove-button {
  background-color: transparent;
  border: none;
  color: #f44336;
  cursor: pointer;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.remove-button:hover {
  color: #c62828;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.75rem 1.5rem;
}

.form-group {
  flex: 1 1 200px;
  margin: 0 0.75rem 1rem;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #424242;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #0d47a1;
  box-shadow: 0 0 0 2px rgba(13, 71, 161, 0.2);
}

.form-group input.error,
.form-group select.error {
  border-color: #f44336;
}

.error-text {
  display: block;
  color: #f44336;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

.calculation-result {
  background-color: #f5f7fa;
  border-radius: 4px;
}

.calculated-value {
  background-color: #f5f7fa;
  padding: 0.75rem;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  font-weight: 500;
  color: #333;
  min-height: 46px;
  display: flex;
  align-items: center;
}

.calculated-value.amount {
  background-color: #e3f2fd;
  color: #0d47a1;
  font-weight: bold;
  border-color: #bbdefb;
}

.calculation-result .rate-input {
  background-color: #f5f7fa;
  padding: 0.75rem;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  font-weight: 500;
  color: #333;
  width: 100%;
  font-size: 1rem;
}

.calculation-result .rate-input:focus {
  border-color: #0d47a1;
  box-shadow: 0 0 0 2px rgba(13, 71, 161, 0.2);
  background-color: #fff;
}

.customer-search-container {
  position: relative;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  color: #757575;
}

.clear-customer-button {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  color: #f44336;
  cursor: pointer;
  transition: color 0.3s;
}

.clear-customer-button:hover {
  color: #c62828;
}

.customers-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.customer-item {
  padding: 0.75rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.customer-item:hover {
  background-color: #f5f5f5;
}

.no-results {
  padding: 0.75rem;
  color: #757575;
  text-align: center;
}

.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.add-collection-button,
.submit-button {
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.add-collection-button {
  background-color: #e3f2fd;
  color: #0d47a1;
  border: 1px solid #bbdefb;
}

.add-collection-button:hover {
  background-color: #bbdefb;
}

.submit-button {
  background-color: #0d47a1;
  color: white;
  border: none;
}

.submit-button:hover {
  background-color: #0a3880;
}

.add-collection-button svg,
.submit-button svg {
  margin-right: 0.5rem;
}

.submit-button:disabled {
  background-color: #9e9e9e;
  cursor: not-allowed;
}

/* Loading spinner */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid rgba(13, 71, 161, 0.2);
  border-top-color: #0d47a1;
  animation: spin 1s infinite linear;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bulk-collection-header {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .bulk-collection-header h1 {
    margin-top: 1rem;
    text-align: left;
  }

  .form-group {
    flex: 1 1 100%;
  }

  .actions {
    flex-direction: column;
  }

  .add-collection-button,
  .submit-button {
    width: 100%;
    justify-content: center;
    margin-bottom: 1rem;
  }
}

/* Add New Customer Item in Dropdown */
.add-new-customer {
  background-color: #e3f2fd;
  border-top: 1px solid #ccc;
  color: #0D47A1;
  font-weight: 500;
}

.add-new-customer:hover {
  background-color: #bbdefb;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* New Customer Modal */
.new-customer-modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 95%;
  max-width: 600px;
  min-width: 320px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.modal-header h2 {
  margin: 0;
  color: #0D47A1;
  font-size: 1.2rem;
}

.close-modal-button {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #666;
  cursor: pointer;
}

.close-modal-button:hover {
  color: #d32f2f;
}

.modal-body {
  padding: 16px;
  overflow-y: auto;
}

.modal-body .form-group {
  margin-bottom: 16px;
}

.modal-body label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  color: #333;
}

.modal-body input,
.modal-body textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

.modal-body textarea {
  resize: vertical;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  gap: 12px;
  border-top: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.cancel-button,
.save-button {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cancel-button {
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  color: #666;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.save-button {
  background-color: #0D47A1;
  border: 1px solid #0D47A1;
  color: white;
}

.save-button:hover {
  background-color: #0a3b8c;
}

.save-button:disabled {
  background-color: #b0bec5;
  border-color: #b0bec5;
  cursor: not-allowed;
}

/* SNF calculated from CLR styling */
.snf-input-container {
  position: relative;
}

.calculated-snf input {
  background-color: #e8f5e9;
  border-color: #81c784;
}

.snf-source-label {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: #2e7d32;
  font-weight: bold;
  background-color: #c8e6c9;
  padding: 2px 6px;
  border-radius: 4px;
  pointer-events: none;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .bulk-collection-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .bulk-collection-header h1 {
    text-align: center;
    order: 2;
  }

  .back-button {
    order: 1;
    align-self: flex-start;
  }

  .header-actions {
    order: 3;
    align-self: flex-end;
  }

  .bulk-collection-content {
    padding: 1rem;
  }

  .form-row {
    flex-direction: column;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .collection-form {
    padding: 1rem;
  }

  .actions {
    flex-direction: column;
    gap: 1rem;
  }

  .add-collection-button,
  .submit-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BulkCollection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".bulk-collection-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f7fa;\n}\n\n.bulk-collection-header {\n  background-color: #0d47a1;\n  color: white;\n  padding: 1rem 2rem;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-collection-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.back-button {\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s;\n}\n\n.back-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.back-button span {\n  margin-left: 0.5rem;\n}\n\n.bulk-collection-content {\n  flex-grow: 1;\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.current-rate-info {\n  background-color: #e3f2fd;\n  color: #0d47a1;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1.5rem;\n  font-weight: bold;\n  text-align: center;\n  border: 1px solid #bbdefb;\n}\n\n.rate-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.rate-display p {\n  margin: 0;\n}\n\n.edit-rate-button {\n  background-color: transparent;\n  color: #0d47a1;\n  border: 1px solid #0d47a1;\n  padding: 0.3rem 0.8rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s;\n}\n\n.edit-rate-button:hover {\n  background-color: #bbdefb;\n}\n\n.edit-rate-button span {\n  margin-left: 0.5rem;\n}\n\n.rate-edit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rate-input {\n  margin: 0 0.5rem;\n  padding: 0.5rem;\n  width: 100px;\n  border: 1px solid #bbdefb;\n  border-radius: 4px;\n  font-size: 1rem;\n  text-align: center;\n}\n\n.save-rate-button {\n  background-color: #0d47a1;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.save-rate-button:hover {\n  background-color: #0a3880;\n}\n\n.save-rate-button span {\n  margin-left: 0.5rem;\n}\n\n.success-message,\n.error-message {\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.success-message {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #c8e6c9;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  border: 1px solid #ffcdd2;\n}\n\n.success-message svg,\n.error-message svg {\n  margin-right: 0.75rem;\n}\n\n.collections-container {\n  margin-bottom: 2rem;\n}\n\n.no-collections {\n  background-color: white;\n  border-radius: 8px;\n  padding: 2rem;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  color: #666;\n}\n\n.collection-form {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.collection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #eee;\n}\n\n.collection-header h3 {\n  margin: 0;\n  color: #0d47a1;\n}\n\n.remove-button {\n  background-color: transparent;\n  border: none;\n  color: #f44336;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: color 0.3s;\n}\n\n.remove-button:hover {\n  color: #c62828;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -0.75rem 1.5rem;\n}\n\n.form-group {\n  flex: 1 1 200px;\n  margin: 0 0.75rem 1rem;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #424242;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: #0d47a1;\n  box-shadow: 0 0 0 2px rgba(13, 71, 161, 0.2);\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: #f44336;\n}\n\n.error-text {\n  display: block;\n  color: #f44336;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n}\n\n.calculation-result {\n  background-color: #f5f7fa;\n  border-radius: 4px;\n}\n\n.calculated-value {\n  background-color: #f5f7fa;\n  padding: 0.75rem;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n  font-weight: 500;\n  color: #333;\n  min-height: 46px;\n  display: flex;\n  align-items: center;\n}\n\n.calculated-value.amount {\n  background-color: #e3f2fd;\n  color: #0d47a1;\n  font-weight: bold;\n  border-color: #bbdefb;\n}\n\n.calculation-result .rate-input {\n  background-color: #f5f7fa;\n  padding: 0.75rem;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n  font-weight: 500;\n  color: #333;\n  width: 100%;\n  font-size: 1rem;\n}\n\n.calculation-result .rate-input:focus {\n  border-color: #0d47a1;\n  box-shadow: 0 0 0 2px rgba(13, 71, 161, 0.2);\n  background-color: #fff;\n}\n\n.customer-search-container {\n  position: relative;\n}\n\n.search-icon {\n  position: absolute;\n  top: 50%;\n  right: 0.75rem;\n  transform: translateY(-50%);\n  color: #757575;\n}\n\n.clear-customer-button {\n  position: absolute;\n  top: 50%;\n  right: 0.75rem;\n  transform: translateY(-50%);\n  background-color: transparent;\n  border: none;\n  color: #f44336;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n\n.clear-customer-button:hover {\n  color: #c62828;\n}\n\n.customers-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.customer-item {\n  padding: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.customer-item:hover {\n  background-color: #f5f5f5;\n}\n\n.no-results {\n  padding: 0.75rem;\n  color: #757575;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n\n.add-collection-button,\n.submit-button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s;\n}\n\n.add-collection-button {\n  background-color: #e3f2fd;\n  color: #0d47a1;\n  border: 1px solid #bbdefb;\n}\n\n.add-collection-button:hover {\n  background-color: #bbdefb;\n}\n\n.submit-button {\n  background-color: #0d47a1;\n  color: white;\n  border: none;\n}\n\n.submit-button:hover {\n  background-color: #0a3880;\n}\n\n.add-collection-button svg,\n.submit-button svg {\n  margin-right: 0.5rem;\n}\n\n.submit-button:disabled {\n  background-color: #9e9e9e;\n  cursor: not-allowed;\n}\n\n/* Loading spinner */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f5f7fa;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 3px solid rgba(13, 71, 161, 0.2);\n  border-top-color: #0d47a1;\n  animation: spin 1s infinite linear;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .bulk-collection-header {\n    padding: 1rem;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .bulk-collection-header h1 {\n    margin-top: 1rem;\n    text-align: left;\n  }\n\n  .form-group {\n    flex: 1 1 100%;\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n\n  .add-collection-button,\n  .submit-button {\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 1rem;\n  }\n}\n\n/* Add New Customer Item in Dropdown */\n.add-new-customer {\n  background-color: #e3f2fd;\n  border-top: 1px solid #ccc;\n  color: #0D47A1;\n  font-weight: 500;\n}\n\n.add-new-customer:hover {\n  background-color: #bbdefb;\n}\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* New Customer Modal */\n.new-customer-modal {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  width: 95%;\n  max-width: 600px;\n  min-width: 320px;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f5f5f5;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #0D47A1;\n  font-size: 1.2rem;\n}\n\n.close-modal-button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #666;\n  cursor: pointer;\n}\n\n.close-modal-button:hover {\n  color: #d32f2f;\n}\n\n.modal-body {\n  padding: 16px;\n  overflow-y: auto;\n}\n\n.modal-body .form-group {\n  margin-bottom: 16px;\n}\n\n.modal-body label {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 500;\n  color: #333;\n}\n\n.modal-body input,\n.modal-body textarea {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.modal-body textarea {\n  resize: vertical;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px;\n  gap: 12px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f5f5f5;\n}\n\n.cancel-button,\n.save-button {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cancel-button {\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  color: #666;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.save-button {\n  background-color: #0D47A1;\n  border: 1px solid #0D47A1;\n  color: white;\n}\n\n.save-button:hover {\n  background-color: #0a3b8c;\n}\n\n.save-button:disabled {\n  background-color: #b0bec5;\n  border-color: #b0bec5;\n  cursor: not-allowed;\n}\n\n/* SNF calculated from CLR styling */\n.snf-input-container {\n  position: relative;\n}\n\n.calculated-snf input {\n  background-color: #e8f5e9;\n  border-color: #81c784;\n}\n\n.snf-source-label {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.75rem;\n  color: #2e7d32;\n  font-weight: bold;\n  background-color: #c8e6c9;\n  padding: 2px 6px;\n  border-radius: 4px;\n  pointer-events: none;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .bulk-collection-header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .bulk-collection-header h1 {\n    text-align: center;\n    order: 2;\n  }\n\n  .back-button {\n    order: 1;\n    align-self: flex-start;\n  }\n\n  .header-actions {\n    order: 3;\n    align-self: flex-end;\n  }\n\n  .bulk-collection-content {\n    padding: 1rem;\n  }\n\n  .form-row {\n    flex-direction: column;\n  }\n\n  .form-group {\n    margin-bottom: 1rem;\n  }\n\n  .collection-form {\n    padding: 1rem;\n  }\n\n  .actions {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .add-collection-button,\n  .submit-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
